import { render, staticRenderFns } from "./gdHome.vue?vue&type=template&id=af9aed80&scoped=true"
import script from "./gdHome.vue?vue&type=script&lang=js"
export * from "./gdHome.vue?vue&type=script&lang=js"
import style0 from "./gdHome.vue?vue&type=style&index=0&id=af9aed80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9aed80",
  null
  
)

export default component.exports